var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('StockviewTabs'),(_vm.summary)?_c('ActionBar',{attrs:{"count":_vm.actionableVehicles}}):_vm._e(),(_vm.seller && _vm.summary)?_vm._t("default"):_c('div',[(!_vm.seller)?_c('TableEmpty',{attrs:{"text":!_vm.isAdmin
            ? 'This branch is currently not attached to a seller'
            : 'Select a dealership to populate'}}):_c('button',{staticClass:"button is-large is-white is-loading"})],1)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }